export const getEditBindingsSuccess = (name: string): string =>
  `Привязки к мобильным приложениям для группы "${name}" обновлены`;
export const getEditBindingsError = (name: string): string =>
  `Не удалось обновить привязки к мобильным приложениям для группы "${name}"`;
